/* eslint-disable react/prop-types */

function TipsCourseWiseAndSplit({ setTipsFor, tipType, setTipType, amount, setAmount, saveTipsInfo }) {


    const percentages = ["0","2", "5", "10", "15", "20", "30"];


    const handleConfirm = () => {
        saveTipsInfo(amount);
        setTipsFor(null);
    }


    return (
        <div className="w-[500px] bg-color2 p-6 rounded-md border-2 border-color3 shadow-2xl text-white flex flex-col gap-5">
            <h2 className="text-xl font-semibold text-center mb-2">Tips / Gratuity</h2>

            {/* Toggle Tabs */}
            <div className="flex gap-4 w-full">
                <button 
                    onClick={() => setTipType("percentage")}
                    className={`flex-1 py-3 rounded-md font-medium transition-colors ${
                        tipType === "percentage" 
                        ? "bg-yellow-500 text-black" 
                        : " bg-color3 text-white hover:bg-gray-500"
                    }`}
                >
                    Percentage
                </button>
                <button 
                    onClick={() => setTipType("fixed")}
                    className={`flex-1 py-3 rounded-md font-medium transition-colors ${
                        tipType === "fixed" 
                        ? "bg-yellow-500 text-black" 
                        : " bg-color3 text-white hover:bg-gray-500"
                    }`}
                >
                    Fixed Amount
                </button>
            </div>

            {/* Input Field */}
            <div className="flex flex-col gap-2">
                <label className="text-sm font-medium">Tips Amount</label>
                <input 
                    type="text" 
                    value={amount}
                    onChange={(e) => setAmount(e.target.value)}
                    placeholder="Enter tips amount" 
                    className="w-full p-3 bg-color3 border border-gray-600 rounded-md outline-none focus:border-gray-400 placeholder-gray-500" 
                />
            </div>

            {/* Quick Select Grid */}
            <div className="grid grid-cols-3 gap-4">
                {percentages.map((p) => (
                    <button 
                        key={p}
                        onClick={() => setAmount(p)}
                        className=" bg-color3 hover:bg-gray-500 text-white py-6 rounded-md font-bold text-lg transition-colors"
                    >
                        {p}
                    </button>
                ))}
            </div>

            {/* Footer Actions */}
            <div className="flex gap-4 mt-4">
                <button 
                    onClick={() => setTipsFor(null)} 
                    className="flex-1 bg-red-500 hover:bg-red-600 text-white py-3 rounded-md font-medium transition-colors"
                >
                    Close
                </button>
                <button 
                    onClick={handleConfirm}
                    className="flex-1 bg-green-500 hover:bg-green-600 text-white py-3 rounded-md font-medium transition-colors"
                >
                Confirm
                </button>
            </div>
        </div>
    );
}

export default TipsCourseWiseAndSplit;